export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const LOCAL_STORAGE = {
  LANGUAGE: 'VCBS_Language',
  ACCESS_TOKEN: 'VCBS_AccessToken',
  ACCESS_RECRUITMENT_TOKEN: 'VCBS_AccessRecruitmentToken',
  CURRENT_PAGE: 'VCBS_CurrentPage',
  AC_THEME: 'VCBS_AcTheme',
  X_IS_SSO: 'VCBS_X-IS-SSO',
  IS_LOGOUT_SSO: 'VCBS_is_logout_sso',
  IS_OPEN_TRADING: 'VCBS_Is_Open_Trading',
  IS_RECRUITMENT: 'VCBS_Is_Recruitment',
  RM_OTP_RESEND_TIME: 'VCBS_RM_OtpResendTime',
  RM_OTP_PHONE: 'VCBS_RM_OtpPhone',
  RM_REGISTER_KEY: 'VCBS_RM_RegisterKey',
  STEP: 'VCBS_STEP',
  INNER_STEP: 'VCBS_INNER_STEP',
  UUID: 'VCBS_UUID',
  EMAIL: 'VCBS_EMAIL',
  PHONE: 'VCBS_PHONE',
  OTP_RESEND_TIME: 'VCBS_OTP_RESEND_TIME',
  OTP_VERIFY_TIME: 'VCBS_OTP_VERIFY_TIME',
};

export const MENU_CODE = {
  MENU_HEADER: 'menu-header',
  MENU_ABOUT_US: 'menu-about-us',
  MENU: 'menu',
  MENU_HEADER_2: 'menu-header-2',
  MENU_IC: 'menu-ic',
  MENU_OC: 'menu-oc',
  MENU_IB: 'menu-ib',
  MENU_TS: 'menu-ts',
  MENU_NEWS: 'menu-news',
  MENU_TI: 'menu-ti',
  MENU_FOOTER_2: 'menu-footer-2',
  MENU_HEADER_CR: 'header-cr',
  MENU_FOOTER_CR: 'footer-cr',
};

export const FOOTER_CATEGORY = {
  FOOTER_INDIVIDUAL: 'menu-ic',
  FOOTER_ORGANIZATION: 'menu-oc',
  FOOTER_ABOUT: 'menu-about',
  FOOTER_ANALYTIC: 'analytic',
  FOOTER_SUPPORT: 'menu-ts',
};

export const GOOGLE_MAP_API_KEY = 'AIzaSyBSdxBfO-pK1xlaiLyBUET-oLS4_WxZ7SY';

export const DEFAULT_QUERY_OPTION = {
  retry: 0,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

export type ConstantRoutesCodes = keyof typeof CONSTANT_ROUTE;
export type ConstantRoutesType = typeof CONSTANT_ROUTE;

export const CONSTANT_ROUTE = {
  LOGIN: 'dang-nhap',
  CHANGE_PASSWORD: 'doi-mat-khau',
  FORGOT_PASSWORD: 'quen-mat-khau',
  RECRUIT_VERIFY_OTP: 'xac-thuc-otp-dang-ky-tuyen-dung',
  RECRUIT_MANAGE_PROFILE: 'quan-ly-ho-so-tuyen-dung',
  ABOUT_DEPARTMENT: 'bo-may-quan-ly',
  INDIVIDUAL_CUSTOMER: 'khach-hang-ca-nhan',
  INDIVIDUAL_CUSTOMER_DETAIL: 'chi-tiet-khach-hang-ca-nhan',
  ORGANIZE_CUSTOMER: 'khach-hang-to-chuc',
  BANK_INVESTMENT: 'dich-vu-nhdt',
  BANK_INVESTMENT_DETAIL: 'chi-tiet-dich-vu-nhdt',
  TRANSACTION_FEE: 'bieu-phi',
  TRANSACTION_SUPPORT_DETAIL: 'chi-tiet-ho-tro-giao-dich',
  NEWS_DISCLOSURE: 'cong-bo-thong-tin',
  NEWS_SGDCK: 'tin-tuc-sgdck',
  NEWS_DISCLOSURE_DETAIL: 'chi-tiet-cong-bo-thong-tin',
  NEWS_SGDCK_DETAIL: 'chi-tiet-tin-tuc-sgdck',
  NEWS_VCBS_DETAIL: 'chi-tiet-tin-tuc-va-su-kien-vcbs',
  SEARCH: 'ket-qua-tim-kiem',
  RECRUITMENT_DETAILS: 'chi-tiet-tuyen-dung',
  IDENTITY_VERIFICATION: 'xac-thuc-danh-tinh',
  RECRUITMENT: 'tuyen-dung',
  JOIN_REASON_DETAIL: 'ly-do-gia-nhap-chi-tiet',
  RECRUITMENT_CV_APPLICATION: 'cv-ung-tuyen',
  RECRUITMENT_CV_EDIT: 'dieu-chinh-cv',
  SAVED_JOB: 'cong-viec-da-luu',
  RM_APPLIED_JOB: 'cong-viec-da-ung-tuyen',
  APPLIED_JOB_CV: 'tai-len-cv',
  EKYC: 'ekyc',
  TRANSACTION_REGISTER: 'dang-ky-giao-dich',
  REGISTER_BOND_TRADING: 'dang-ky-giao-dich-trai-phieu',
  BOND_INDIVIDUALS_INFO: 'thong-tin-trai-phieu-va-ca-nhan',
  COMPLETE_REGISTER_BOND: 'hoan-thanh-dang-ky-giao-dich-trai-phieu',
  ANALYSIS_REPORT_PREVIEW: 'bao-cao-phan-tich',
};

export const CONSTANT_ROUTE_EN: ConstantRoutesType = {
  LOGIN: 'login',
  CHANGE_PASSWORD: 'change-password',
  FORGOT_PASSWORD: 'forgot-password',
  RECRUIT_VERIFY_OTP: 'verify-otp-recruit-registration',
  RECRUIT_MANAGE_PROFILE: 'manage-profile-recruitment',
  ABOUT_DEPARTMENT: 'departments',
  INDIVIDUAL_CUSTOMER: 'individual-customer',
  INDIVIDUAL_CUSTOMER_DETAIL: 'individual-customer-detail',
  ORGANIZE_CUSTOMER: 'organize-customer',
  BANK_INVESTMENT: 'bank-investment',
  BANK_INVESTMENT_DETAIL: 'bank-investment-detail',
  TRANSACTION_FEE: 'transaction-fee',
  TRANSACTION_SUPPORT_DETAIL: 'transaction-support-detail',
  NEWS_DISCLOSURE: 'disclosure-news',
  NEWS_SGDCK: 'sgdck-news',
  NEWS_DISCLOSURE_DETAIL: 'disclosure-news-detail',
  NEWS_SGDCK_DETAIL: 'sgdck-news-detail',
  NEWS_VCBS_DETAIL: 'vcbs-news-detail',
  SEARCH: 'search-results',
  RECRUITMENT_DETAILS: 'recruitment-details',
  IDENTITY_VERIFICATION: 'authenticated-user',
  RECRUITMENT: 'recruitment',
  JOIN_REASON_DETAIL: 'join-reason-detail',
  RECRUITMENT_CV_APPLICATION: 'application-cv',
  RECRUITMENT_CV_EDIT: 'edit-cv',
  SAVED_JOB: 'saved-job',
  RM_APPLIED_JOB: 'rm-applied-job',
  APPLIED_JOB_CV: 'application-cv-file',
  EKYC: 'ekyc',
  TRANSACTION_REGISTER: 'transaction-register',
  REGISTER_BOND_TRADING: 'register-bond-trading',
  BOND_INDIVIDUALS_INFO: 'bond-individuals-info',
  COMPLETE_REGISTER_BOND: 'complete-register-bond-trading',
  ANALYSIS_REPORT_PREVIEW: 'analysis-reports',
};

export const CONSTANT_LANGUAGE_LIST = ['vi', 'en'];

export type ACConstantRoutesCodes = keyof typeof AC_CONSTANT_ROUTE;
export type ACConstantRoutesType = typeof AC_CONSTANT_ROUTE;

export const AC_CONSTANT_ROUTE = {
  DASHBOARD: '/trung-tam-phan-tich',
  DETAIL_REPORT: '/trung-tam-phan-tich/bao-cao-chi-tiet',
  BUSINESS_PROFILE: '/trung-tam-phan-tich/ho-so-doanh-nghiep',
  BENEFIT_HISTORY: '/trung-tam-phan-tich/lich-su-huong-quyen',
  ANALYSIS_REPORT: '/trung-tam-phan-tich/bao-cao-phan-tich',
  RASING_HISTORY: '/trung-tam-phan-tich/lich-su-tang-von',
  TRANSACTION_HISTORY: '/trung-tam-phan-tich/lich-su-giao-dich',
  AUTOMATIC_ASSESSMENT: '/trung-tam-phan-tich/danh-gia-tu-dong',
  STOCK_INFORMATION: '/trung-tam-phan-tich/thong-tin-co-phieu',
  ECONOMIC_INFORMATION: '/trung-tam-phan-tich/thong-tin-tai-chinh',
  TECHNICAL_ANALYTIC: '/trung-tam-phan-tich/phan-tich-ky-thuat',
  BUSINESS_NEWS: '/trung-tam-phan-tich/tin-tuc-doanh-nghiep',
};

export const AC_CONSTANT_ROUTE_EN: ACConstantRoutesType = {
  DASHBOARD: '/analysis-center',
  DETAIL_REPORT: '/analysis-center/detail-report',
  BUSINESS_PROFILE: '/analysis-center/business-profile',
  BENEFIT_HISTORY: '/analysis-center/benefit-history',
  ANALYSIS_REPORT: '/analysis-center/analysis-report',
  RASING_HISTORY: '/analysis-center/rasing-history',
  TRANSACTION_HISTORY: '/analysis-center/transaction-history',
  AUTOMATIC_ASSESSMENT: '/analysis-center/automatic-assessment',
  STOCK_INFORMATION: '/analysis-center/stock-information',
  ECONOMIC_INFORMATION: '/analysis-center/economic-information',
  TECHNICAL_ANALYTIC: '/analysis-center/technical-analytic',
  BUSINESS_NEWS: '/analysis-center/business-news',
};

export const AC_ROUTE_DETAIL = [
  {
    vi: '/trung-tam-phan-tich/bao-cao-chi-tiet',
    en: '/analysis-center/detail-report',
  },
  {
    vi: '/trung-tam-phan-tich/ho-so-doanh-nghiep',
    en: '/analysis-center/business-profile',
  },
  {
    vi: '/trung-tam-phan-tich/lich-su-huong-quyen',
    en: '/analysis-center/benefit-history',
  },
  {
    vi: '/trung-tam-phan-tich/bao-cao-phan-tich',
    en: '/analysis-center/analysis-report',
  },
  {
    vi: '/trung-tam-phan-tich/lich-su-tang-von',
    en: '/analysis-center/rasing-history',
  },
  {
    vi: '/trung-tam-phan-tich/lich-su-giao-dich',
    en: '/analysis-center/transaction-history',
  },
  {
    vi: '/trung-tam-phan-tich/danh-gia-tu-dong',
    en: '/analysis-center/automatic-assessment',
  },
  {
    vi: '/trung-tam-phan-tich/thong-tin-co-phieu',
    en: '/analysis-center/stock-information',
  },
  {
    vi: '/trung-tam-phan-tich/thong-tin-tai-chinh',
    en: '/analysis-center/economic-information',
  },
  {
    vi: '/trung-tam-phan-tich/phan-tich-ky-thuat',
    en: '/analysis-center/technical-analytic',
  },
  {
    vi: '/trung-tam-phan-tich/tin-tuc-doanh-nghiep',
    en: '/analysis-center/business-news',
  },
];

export const Bank = ['289', '297', '298']; // Bank: icb_id in (289, 297, 298)
export const Insurance = ['292', '293', '294']; // Insurance: icb_id in (292, 293, 294)
export const Securities = ['300']; // Securities: icb_id in (300)
export const Companies = ['289', '297', '298', '292', '293', '294', '300']; // Companies: icb_id not in (289, 297, 298, 292, 293, 294, 300)
export const LocationOpenAccountId = {
  VCBSHO: {
    name: 'VCBS-HO',
    code: '0001',
  },
  HCM: {
    name: 'HCM',
    code: '0101',
  },
  DN: {
    name: 'Đà nẵng',
    code: '0201',
  },
};

export type ConstantExternalRoutesCodes = keyof typeof CONSTANT_EXTERNAL_ROUTE;
export type ConstantExternalRoutesType = typeof CONSTANT_EXTERNAL_ROUTE;

export const CONSTANT_EXTERNAL_ROUTE = {
  ABOUT_DEPARTMENT: 'bo-may-quan-ly-chi-tiet',
  INDIVIDUAL_CUSTOMER: 'khach-hang-ca-nhan-chi-tiet',
};

export const CONSTANT_EXTERNAL_ROUTE_EN = {
  ABOUT_DEPARTMENT: 'departments-detail',
  INDIVIDUAL_CUSTOMER: 'individual-customer-detail',
};

export const OFFSET_LIMIT = {
  SGDCK_NEWS: 10,
  AC_BUSINESS_NEWS: 15,
};
